module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Hi! I'm Michael!","short_name":"Hi! I'm Michael!","start_url":"/gatsby-mywebsite","background_color":"#ffffff","theme_color":"#252527","display":"minimal-ui","icon":"static/images/avatar.jpg","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"4eccd6a17aeb9fb9208f6e6f54609cce"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
